<template>
    <div class="field">
        <label @click="toggle" :for="name" class="checkbox"
               :class="{ 'is-danger': errors.hasError(name) }">
            <input type="hidden" :name="name" :id="name" v-model="checked">
            <span class="icon"><i class="far" :class="{ 'fa-square': !checked, 'fa-check-square': checked }"></i></span>
            <slot></slot>
        </label>
        <p class="help is-danger mb-0" v-text="errors.get( name )"></p>
    </div>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: Boolean,
                required: false
            },
            errors: {
                type: Object,
                required: false
            }
        },
        mounted() {
            if( typeof this.value === 'boolean') {
                this.checked = this.value
            }
        },
        data() {
            return {
                checked: false
            }
        },
        methods: {
            toggle() {
                this.checked = !this.checked
                this.$emit('input', this.checked)
            }
        },
        watch: {
            value( check ) {
                if( typeof check === 'boolean') {
                    this.checked = check
                }
            }
        }
    }
</script>